import React, { useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import * as XLSX from "xlsx";
import { MoreOutlined, DownOutlined, ReloadOutlined, DeleteRowOutlined } from "@ant-design/icons";
import { Dropdown, Menu } from "antd";
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Input,
  Row,
  Select,
  Space,
  Table,
  DatePicker,
  Typography,
  Modal,
  Form,

  Flex,
  Tag,
  notification,
  Upload,
  Radio,
} from "antd";
import { CheckSquareOutlined } from "@ant-design/icons";


import {
  CalculatorOutlined,
  CloudDownloadOutlined,
  CloudUploadOutlined,
  DeleteOutlined,
  ImportOutlined,
  SyncOutlined,
  MinusSquareOutlined,
  MinusCircleOutlined,
  LeftOutlined,
  RightOutlined,
  FilterOutlined,
  WarningOutlined,
  CheckCircleOutlined,
  SearchOutlined,
  CalendarOutlined,
  BankOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { InterroComptaService } from "../Services/InterroComptaService";
import { AdherentsService } from "../Services/AdherentsService";
import { RetenueService } from "../Services/RetenueService";
import moment from "moment";
import dayjs from "dayjs";
import "../Pages/CSS/Traitement.css";
import { TraitementService } from "../Services/TraitementService";

const DraggableModal = ({ children, ...props }) => {
  const [disabled, setDisabled] = useState(true);
  const draggleRef = useRef(null);

  return (
    <Modal
      {...props}
      modalRender={(modal) => (
        <Draggable
          disabled={disabled}
          bounds={draggleRef.current ? draggleRef.current : undefined}
          handle=".ant-modal-title"
        >
          <div ref={draggleRef}>{modal}</div>
        </Draggable>
      )}
      title={
        <div
          className="ant-modal-title"
          style={{ width: '100%', cursor: 'move' }}
          onMouseOver={() => setDisabled(false)}
          onMouseOut={() => setDisabled(true)}
        >
          {props.title}
        </div>
      }
    >
      {children}
    </Modal>
  );
};

const { Title } = Typography;
const { Option } = Select;

// Colonnes attendues (noms et ordre) dans le fichier Excel d'import des retenues
const IMPORT_RETENUE_COLUMNS = [
  "Code Retenue",
  "Matricule",
  "Participant",
  "Code soc.",
  "Solde",
  "Retenue IPM",
  "Retenue Paie",
];

const Retenue = () => {
  const [form] = Form.useForm();

  const interroComptService = new InterroComptaService();
  const traitementsoinsService = new TraitementService()
  const retenueService = new RetenueService();
  const adherentsService = new AdherentsService();
  const getSelectedYear = () => {
    const currentYear = new Date().getFullYear();
    return currentYear.toString();
  };
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [paramData, setParamData] = useState([]);
  const [filterMode, setFilterMode] = useState("tout");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedCodesoc, setSelectedCodesoc] = useState(null);
  const [journalData, setJournalData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectJournal, setSelectJournal] = useState("AA");
  const [selectedMonth, setSelectedMonth] = useState(
    dayjs().format("MM")
  );
  const [pageSize, setPageSize] = useState(10);
  const [isImportModalVisible, setIsImportModalVisible] = useState(false);
  const [importedData, setImportedData] = useState([]);
  const [importErrors, setImportErrors] = useState([]);
  const [isImporting, setIsImporting] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comptaPreviewData, setComptaPreviewData] = useState([]);
  const [filteredTableData, setFilteredTableData] = useState([]);
  const [displayedTableData, setDisplayedTableData] = useState([]);
  const [typeRapproche, setTypeRapproche] = useState("non");

  const fetchDataInit = async () => {
    const getParam = await traitementsoinsService.getParamComptable();
    setParamData(getParam);
    const yearFromParamData = dayjs(getParam.datedeb).format("YYYY");
    setSelectedYear(yearFromParamData)
    const currentMonth = dayjs().format("MM");
    setSelectedMonth(currentMonth);
    console.log(selectedMonth);

  };

  const currentYear = new Date().getFullYear();
  const lastFiveYears = Array.from({ length: 5 }, (_, i) => currentYear - i);

  useEffect(() => {

    fetchDataInit();
    return () => { };
  }, []);


  const fetchData = async () => {
    setIsLoading(true);
    try {
      const listData = await adherentsService.getAllAdherents();
      console.log(selectedMonth);

      setJournalData(listData);

      const data = await retenueService.getAllRetenue(
        selectedYear,
        selectedMonth,
        selectJournal
      );

      // _rowKey garantit une clé unique par ligne : le couple (code_retenue, matricule)
      // seul n'est pas fiable (plusieurs lignes distinctes peuvent le partager), ce qui
      // provoquait des collisions de clé React (lignes dupliquées visuellement, sélection
      // et pagination erratiques).
      setTableData(data.map((row, index) => ({ ...row, _rowKey: index })));
      await retenueService.getRetenue(
        selectedYear,
        selectedMonth,
        selectJournal
      );
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (selectedYear) {
      fetchData();
    }

  }, [selectJournal, selectedMonth, selectedYear]);

  useEffect(() => { }, [journalData]);

  const handleSelectJournalChange = (value) => {
    console.log("Selected Journal:", value); // Pour débugger
    setSelectJournal(value);
  };

  const journalOptions = ["AA", ...journalData.map((journal) => journal.codeadht)];
  const currentJournalIndex = journalOptions.findIndex((code) => code === selectJournal);

  const handlePreviousJournal = () => {
    if (currentJournalIndex > 0) {
      handleSelectJournalChange(journalOptions[currentJournalIndex - 1]);
    }
  };

  const handleNextJournal = () => {
    if (currentJournalIndex >= 0 && currentJournalIndex < journalOptions.length - 1) {
      handleSelectJournalChange(journalOptions[currentJournalIndex + 1]);
    }
  };

  const journalSelectWidth = 320;

  useEffect(() => {
    setFilteredTableData(tableData);
  }, [tableData]);

  const handleYearChange = (value) => {
    setSelectedYear(value);
  };

  function formatNumber(number) {
    return new Intl.NumberFormat("fr-FR").format(number);
  };



  const fetchTableData = async () => {
    setIsLoading(true);
    try {
      const rapprochementData = await interroComptService.getRapprochement(
        selectedYear,
        selectedMonth,
        selectJournal
      );

      const postData = [...rapprochementData];
      const addResponse = await interroComptService.addRapprochement(postData);
      console.log("addRapprochement response:", addResponse);

      // Vérifie si l'ajout a été confirmé par le serveur
      if (addResponse && addResponse.Added) {
        const newData = await interroComptService.getListTable(
          typeRapproche,
          selectedYear,
          selectedMonth,
          selectJournal
        );

        // Mettre à jour l'état avec les nouvelles données qui doivent refléter l'état 'Ajout' à 'true'
        setTableData(newData);
      } else {
        console.error("addRapprochement failed or not added:", addResponse);
      }
    } catch (error) {
      console.error("Error during data fetch or update:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const filteredData = tableData.filter(item => {
      if (selectJournal === "AA") {
        return true; // Pas de filtrage si "Toutes les sociétés" est sélectionné
      }
      return item.codesoc === selectJournal;
    });
    setFilteredTableData(filteredData);
  }, [selectJournal, tableData, selectedMonth, selectedYear]);

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      const response = await interroComptService.deleteRetenue(
        selectedYear,
        selectedMonth,
        selectJournal
      );

      notification.success({
        message: "Suppression réussie",
        description:
          "Les retenues sélectionnées ont été supprimées avec succès.",
      });

      fetchData();
    } catch (error) {
      notification.error({
        message: "Erreur lors de la suppression",
        description:
          "Une erreur est survenue lors de la suppression des retenues.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const onSelectChange = (selectedKeys, selectedRowP) => {
    if (selectedRowP.length === 0) {
      // Si aucune ligne n'est sélectionnée, réinitialisez le selectedCodesoc
      setSelectedCodesoc(null);
      setSelectedRows([]);
      return;
    }

    const selectedCodesocValue = selectedRowP[0].codesoc;

    // Filtrer les lignes sélectionnées pour inclure toutes les lignes ayant le même codesoc
    const rowsWithSameCodesoc = tableData.filter(row => row.codesoc === selectedCodesocValue);

    setSelectedCodesoc(selectedCodesocValue);
    setSelectedRows(rowsWithSameCodesoc);
  };

  // Sélection multiple : la case de l'entête sélectionne/désélectionne toutes les lignes
  // filtrées en un seul clic (et non uniquement celles de la page courante, comportement
  // par défaut d'Ant Design)
  // _rowKey (assigné à la récupération des données, cf. fetchData) garantit une clé unique :
  // le couple (code_retenue, matricule) seul n'est pas fiable (plusieurs lignes distinctes
  // peuvent le partager), ce qui provoquait des collisions de clé React côté antd Table
  // (lignes dupliquées visuellement, sélection et pagination erratiques). L'index d'antd
  // (passé par le composant Table) est relatif à la page courante, donc inutilisable ici
  // pour garantir l'unicité sur l'ensemble des pages.
  const getRetenueRowKey = (record) =>
    record._rowKey !== undefined ? `retenue-${record._rowKey}` : `${record.code_retenue}-${record.matricule}`;

  // Réinitialise les données affichées (filtres colonnes) chaque fois que la source change
  useEffect(() => {
    setDisplayedTableData(filteredTableData);
  }, [filteredTableData]);

  const handleRetenueTableChange = (pagination, filters, sorter, extra) => {
    setDisplayedTableData(extra.currentDataSource);
  };

  // Basé sur les données réellement affichées (après filtres de colonnes), pas seulement
  // sur filteredTableData, pour que "tout sélectionner" ne porte que sur les écritures filtrées.
  const allFilteredRowKeys = displayedTableData.map(getRetenueRowKey);
  const isAllRowsSelected =
    allFilteredRowKeys.length > 0 &&
    allFilteredRowKeys.every((key) => selectedRowKeys.includes(key));
  const isRowsPartiallySelected =
    !isAllRowsSelected &&
    allFilteredRowKeys.some((key) => selectedRowKeys.includes(key));

  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setSelectedRows(selectedRows);
      // Si besoin, vous pouvez aussi gérer selectedCodesoc ici
      // setSelectedCodesoc(selectedRows.length > 0 ? selectedRows[0].codesoc : null);
    },
    columnTitle: (
      <Checkbox
        checked={isAllRowsSelected}
        indeterminate={isRowsPartiallySelected}
        onChange={(e) => {
          if (e.target.checked) {
            setSelectedRowKeys(allFilteredRowKeys);
            setSelectedRows(displayedTableData);
          } else {
            setSelectedRowKeys([]);
            setSelectedRows([]);
          }
        }}
      />
    ),
    // Si vous voulez désactiver la sélection selon une condition, décommentez ci-dessous :
    // getCheckboxProps: (record) => ({
    //   disabled: false, // ou votre logique de désactivation
    // }),
  };



  const isButtonDisabled = selectedRows.length === 0;

  const generateFileName = (
    selectedMonth,
    selectedYear,
    selectJournal,
    tableData,
    monthOptions
  ) => {
    const monthLabel = `Solde Frais Medicaux - ${monthOptions.find((m) => m.value === selectedMonth)?.label ||
      "Mois non sélectionné"
      }`;
    const journalLabel = getJournalLabel(selectJournal);
    const participantCount = tableData.length;
    return `${monthLabel} ${selectedYear} - ${journalLabel} (${participantCount} Participant).xlsx`;
  };

  const exportToExcel = (
    data,
    selectedMonth,
    selectedYear,
    selectJournal,
    tableData,
    monthOptions
  ) => {
    // Génération du nom du fichier
    const fileName = generateFileName(
      selectedMonth,
      selectedYear,
      selectJournal,
      tableData,
      monthOptions
    );

    // Mappage des noms des colonnes
    const mapColumns = (data) => {
      return data.map((row) => ({
        "Code Retenue": row.code_retenue,
        "Matricule": row.matricule,
        "Participant": row.part,
        "Code soc.": row.codesoc,
        "Solde": row.solde,
        "Retenue IPM": row.mont_retenue,
        "Retenue Paie": row.mont_retenue_soc,
        "Catégorie": row.categprof,
        "Statut": row.statut,
        "Matricule_Paie": row.matricule_paie,
      }));
    };

    // Mappage des données avec les nouveaux noms des colonnes
    const mappedData = mapColumns(data);

    // Création d'un nouveau classeur
    const workbook = XLSX.utils.book_new();
    // Conversion des données en feuille de travail
    const worksheet = XLSX.utils.json_to_sheet(mappedData);
    // Ajout de la feuille de travail au classeur
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    // Exportation du classeur (cela déclenchera le téléchargement)
    XLSX.writeFile(workbook, fileName);
  };
  const handleFilterChange = (e) => {
    const selectedMode = e.target.value;
    setFilterMode(selectedMode);

    // Filtrage en fonction des montants retenue
    if (selectedMode === "anomalies") {
      // Montants différents
      setFilteredTableData(
        tableData.filter((row) => row.mont_retenue !== row.mont_retenue_soc)
      );
    } else if (selectedMode === "normales") {
      // Montants égaux
      setFilteredTableData(
        tableData.filter((row) => row.mont_retenue === row.mont_retenue_soc)
      );
    } else {
      // Voir tout
      setFilteredTableData(tableData);
    }
  };



  const columns = [
    {
      title: "Code Retenue",
      dataIndex: "code_retenue",
      key: "code_retenue",
      align: "center",
      sorter: (a, b) => {
        if (!a.code_retenue && b.code_retenue) return 1;
        if (a.code_retenue && !b.code_retenue) return -1;
        if (!a.code_retenue && !b.code_retenue) return 0;
        return a.code_retenue.localeCompare(b.code_retenue);
      },
    },
    {
      title: "Matricule",
      dataIndex: "matricule",
      key: "matricule",
      align: "center",
      sorter: (a, b) => {
        if (!a.matricule && b.matricule) return 1;
        if (a.matricule && !b.matricule) return -1;
        if (!a.matricule && !b.matricule) return 0;
        return a.matricule.localeCompare(b.matricule);
      },
    },
    {
      title: "Participant",
      dataIndex: "part",
      key: "part",
      sorter: (a, b) => {
        if (!a.part && b.part) return 1;
        if (a.part && !b.part) return -1;
        if (!a.part && !b.part) return 0;
        return a.part.localeCompare(b.part);
      },
    },
    {
      title: "Code Soc",
      dataIndex: "codesoc",
      key: "codesoc",
      align: "center",
      filters: [
        ...new Set(
          filteredTableData.map((item) => item?.codesoc).filter((value) => value)
        ),
      ]
        .sort((a, b) => a.localeCompare(b))
        .map((value) => ({ text: value, value: value })),
      onFilter: (value, record) => record.codesoc === value,
      sorter: (a, b) => {
        if (!a.codesoc && b.codesoc) return 1;
        if (a.codesoc && !b.codesoc) return -1;
        if (!a.codesoc && !b.codesoc) return 0;
        return a.codesoc.localeCompare(b.codesoc);
      },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Solde
        </div>
      ),
      dataIndex: "solde",
      key: "solde",
      align: "right",
      sorter: (a, b) => {
        const soldeA = a.solde ?? 0;
        const soldeB = b.solde ?? 0;
        return soldeA - soldeB;
      },
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
            {formatNumber(text && parseFloat(text) !== 0 ? parseFloat(text) : "")}
          </strong>
        </div>
      ),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Retenue IPM
        </div>
      ),
      dataIndex: "mont_retenue",
      key: "mont_retenue",
      align: "right",
      sorter: (a, b) => {
        const retenueA = a.mont_retenue ?? 0;
        const retenueB = b.mont_retenue ?? 0;
        return retenueA - retenueB;
      },
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
            {formatNumber(text && parseFloat(text) !== 0 ? parseFloat(text) : "")}
          </strong>
        </div>
      ),
    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            paddingRight: 10,
          }}
        >
          Retenue Paie
        </div>
      ),
      dataIndex: "mont_retenue_soc",
      key: "mont_retenue_soc",
      align: "right",
      sorter: (a, b) => {
        const retenueSocA = a.mont_retenue_soc ?? 0;
        const retenueSocB = b.mont_retenue_soc ?? 0;
        return retenueSocA - retenueSocB;
      },
      render: (text) => (
        <div style={{ paddingRight: 10 }}>
          <strong>
            {formatNumber(text && parseFloat(text) !== 0 ? parseFloat(text) : "")}
          </strong>
        </div>
      ),
    },
    {
      title: "Écart",
      dataIndex: "ecart",
      key: "ecart",
      align: "right",
      render: (text, record) => {
        // Calcul de l'écart
        const ecartValue =
          (record.mont_retenue || 0) -
          (record.mont_retenue_soc || 0);
        return (
          <strong style={{ paddingRight: 16, color: ecartValue !== 0 ? "red" : "green" }}>
            {formatNumber(ecartValue)}
          </strong>
        );
      },
      sorter: (a, b) => {
        const ecartSocA = a.ecart ?? 0;
        const ecartSocB = b.ecart ?? 0;
        return ecartSocA - ecartSocB;
      },
    },
    {
      title: "État",
      dataIndex: "compta",
      key: "compta",
      align: "center",
      sorter: (a, b) => {
        if (!a.compta && b.compta) return 1;
        if (a.compta && !b.compta) return -1;
        if (!a.compta && !b.compta) return 0;
        return a.compta.localeCompare(b.compta);
      },
      filters: [
        { text: "Comptabiliser", value: "Oui" },
        { text: "Non Comptabiliser", value: "Non" },
      ],
      onFilter: (value, record) =>
        value === "Oui" ? record.compta === "Oui" : record.compta !== "Oui",
      render: (text) => (
        <Tag color={text === "Oui" ? "#4be000" : "#fc1303"}>
          {text === "Oui" ? "Comptabiliser" : "Non Comptabiliser"}
        </Tag>
      ),
    },
  ];


  const monthOptions = [
    // { value: "13", label: "Tous les mois" },
    { value: "01", label: "Janvier" },
    { value: "02", label: "Février" },
    { value: "03", label: "Mars" },
    { value: "04", label: "Avril" },
    { value: "05", label: "Mai" },
    { value: "06", label: "Juin" },
    { value: "07", label: "Juillet" },
    { value: "08", label: "Août" },
    { value: "09", label: "Septembre" },
    { value: "10", label: "Octobre" },
    { value: "11", label: "Novembre" },
    { value: "12", label: "Décembre" },
  ];

  const getJournalLabel = (code) => {
    // Trouve le journal correspondant par codej et retourne son libelle
    const journal = journalData.find((j) => j.codeadht === code);
    // Vérifie que journal existe et retourne la chaîne formatée avec codeadht et intitule
    return journal
      ? `${journal.codeadht} - ${journal.intitule}`
      : "Toutes";
  };

  // Basés sur displayedTableData (données réellement affichées, après filtres de colonnes
  // comme "État") plutôt que filteredTableData, pour que ces métriques restent dynamiques
  // quand un filtre de colonne est appliqué.
  const totalRetenue = displayedTableData.reduce(
    (sum, record) => sum + parseFloat(record.mont_retenue_soc || 0),
    0
  );
  const solde = displayedTableData.reduce(
    (sum, record) => sum + parseFloat(record.solde || 0),
    0
  );

  const refreshData = () => {
    fetchData();
  };
  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredTableData(filtered); // Assurez-vous que cette logique de filtrage est correcte
  };

  const handleClick = () => {
    setIsModalVisible(true);
  };

  const handleDeleteSelected = () => {
    if (selectedRows.length === 0) {
      Modal.warning({
        title: "Suppression impossible",
        content: "Veuillez sélectionner au moins une ligne à supprimer.",
        okText: "Fermer",
      });
      return;
    }

    const hasComptaOui = selectedRows.some((row) => row.compta === "Oui");
    if (hasComptaOui) {
      Modal.warning({
        title: "Suppression impossible",
        content:
          "Suppression bloquee : au moins une ligne selectionnee est deja comptabilisee (Etat = Oui).",
        okText: "Fermer",
      });
      return;
    }

    // Le backend attend une liste de code_retenue distincts (List<String>)
    const listCodeRetenue = [...new Set(selectedRows.map((row) => row.code_retenue))];

    Modal.confirm({
      title: "Confirmation",
      content: `Voulez-vous supprimer les ${listCodeRetenue.length} retenue(s) sélectionnée(s) ?`,
      okText: "Oui",
      cancelText: "Annuler",
      onOk: async () => {
        setIsLoading(true);
        try {
          await retenueService.deleteRetenue(listCodeRetenue);
          setSelectedRowKeys([]);
          setSelectedRows([]);
          setSelectedCodesoc(null);
          await fetchData();
          notification.success({ message: "Suppression effectuée" });
        } catch (error) {
          notification.error({
            message: "Erreur lors de la suppression",
            description: "Une erreur est survenue lors de la suppression des retenues.",
          });
        } finally {
          setIsLoading(false);
        }
      }
    });
  };

  const actionMenu = (
    <Menu>
      <Menu.Item key="refresh" onClick={refreshData} icon={<ReloadOutlined />}>
        Actualiser
      </Menu.Item>
      <Menu.Item
        key="delete"
        danger
        onClick={handleDeleteSelected}
        icon={<DeleteRowOutlined />}
        disabled={selectedRows.length === 0 || selectedRows.some((row) => row.compta === "Oui")}
      >
        Supprimer la sélection
      </Menu.Item>
    </Menu>
  );

  // Dropdown Sélection (Tout sélectionner / Tout désélectionner)
  const selectionMenu = (
    <Menu>
      <Menu.Item
        key="selectAll"
        icon={<CheckSquareOutlined />}
        onClick={() => setSelectedRowKeys(filteredTableData.map(getRetenueRowKey))}
      >
        <span className="menu-item-text">Tout Sélectionner</span>
      </Menu.Item>
      <Menu.Item
        key="deselectAll"
        icon={<MinusSquareOutlined />}
        onClick={() => setSelectedRowKeys([])}
      >
        <span className="menu-item-text">Tout Désélectionner</span>
      </Menu.Item>
    </Menu>
  );

  const menuStyles = {
    ".menu-item-text": {
      marginLeft: "0.5rem",
    },
  };

  const handleModalOk = async () => {
    if (selectedYear && selectedMonth && selectJournal) {
      setIsLoading(true);
      try {
        const data = await retenueService.addRetenue(
          selectedYear,
          selectedMonth,
          selectJournal
        );
        notification.success({
          message: "ajout réussie",
          description: "Appel retenue effectué avec succès.",
        });
        fetchData();
        setIsModalVisible(false);
      } catch (error) {
        notification.error({
          message: "Erreur lors de l'appel retenue",
        });
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);

    form.resetFields();
  };

  const handleComptabiliser = async () => {
    if (selectedRows.length === 0) {
      Modal.warning({
        title: "Comptabilisation impossible",
        content: "Veuillez sélectionner au moins une ligne à comptabiliser.",
        okText: "Fermer",
      });
      return;
    }

    if (selectedRows.some((row) => row.compta === "Oui")) {
      Modal.warning({
        title: "Comptabilisation impossible",
        content: "Au moins une ligne sélectionnée est deja comptabilisee.",
        okText: "Fermer",
      });
      return;
    }

    try {
      const data = await retenueService.addPreviewRetenuCompta(selectedRows);
      setComptaPreviewData(data);
      setIsModalOpen(true);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };


  const isTableEmpty = filteredTableData.length === 0;
  const handleExportImportErrors = () => {
    if (importErrors.length === 0) return;

    const dataToExport = importErrors.map((err) => ({
      "Ligne Excel": err.rowNum,
      Colonne: err.field,
      Anomalie: err.message,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Anomalies");
    XLSX.writeFile(workbook, "anomalies_import_retenues.xlsx");
  };

  const handleExcelImport = (file) => {
    setLoading(true); // Active le loading
    const reader = new FileReader();

    try {
      reader.onload = (e) => {
        try {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const sheet = workbook.Sheets[sheetName];
          const parsedData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

          if (parsedData.length === 0) {
            setImportedData([]);
            setImportErrors([{ rowNum: "-", field: "-", message: "Le fichier est vide." }]);
            return;
          }

          const headerRow = parsedData[0].map((h) => (h || "").toString().trim());
          const missingColumns = IMPORT_RETENUE_COLUMNS.filter(
            (col) => !headerRow.includes(col)
          );

          if (missingColumns.length > 0) {
            setImportedData([]);
            setImportErrors([{
              rowNum: "-",
              field: "-",
              message: `Colonne(s) manquante(s) : ${missingColumns.join(", ")}. Merci d'utiliser le modèle fourni.`,
            }]);
            return;
          }

          const dataRows = parsedData
            .slice(1)
            .filter((row) => row.some((cell) => cell !== "" && cell !== undefined && cell !== null));

          const numericColumns = ["Solde", "Retenue IPM", "Retenue Paie"];
          const errors = [];

          const rows = dataRows.map((row, idx) => {
            const excelRowNum = idx + 2; // ligne 1 = entêtes
            const obj = {};
            headerRow.forEach((key, i) => {
              obj[key] = row[i] !== undefined && row[i] !== null ? row[i] : "";
            });

            IMPORT_RETENUE_COLUMNS.forEach((col) => {
              const value = obj[col];
              const isEmpty = value === "" || value === undefined || value === null;
              if (isEmpty) {
                errors.push({ rowNum: excelRowNum, field: col, message: `Cellule vide (${col})` });
              }
            });

            numericColumns.forEach((col) => {
              if (obj[col] !== "" && Number.isNaN(Number(obj[col]))) {
                errors.push({
                  rowNum: excelRowNum,
                  field: col,
                  message: `Valeur invalide : "${obj[col]}"`,
                });
              }
            });

            return obj;
          });

          setImportedData(rows);
          setImportErrors(errors);
        } catch (error) {
          console.error("Erreur lors de la lecture du fichier :", error);
          setImportedData([]);
          setImportErrors([{
            rowNum: "-",
            field: "-",
            message: "Fichier illisible. Vérifiez qu'il s'agit bien d'un fichier Excel (.xlsx).",
          }]);
        } finally {
          setLoading(false);
        }
      };
      reader.readAsBinaryString(file);
      return false;
    } catch (error) {
      console.error("Erreur lors de l'import du fichier :", error);
      setLoading(false);
    }
  };

  const columns1 = [
    {
      title: "Code Retenue",
      dataIndex: "Code Retenue",
      key: "code_retenue",
      align: "center",
      width: 140,
    },
    {
      title: "Matricule",
      dataIndex: "Matricule",
      key: "matricule",
      align: "center",
      width: 120,
    },
    { title: "Participant", dataIndex: "Participant", key: "part", width: 200 },
    {
      title: "Code soc.",
      dataIndex: "Code soc.",
      key: "codesoc",
      align: "center",
      width: 100,
    },
    {
      title: "Solde",
      dataIndex: "Solde",
      key: "solde",
      align: "right",
      width: 130,
      render: (text) => (
        <div style={{ paddingRight: 5 }}>{formatNumber(parseFloat(text))}</div>
      ),
    },
    {
      title: "Retenue IPM",
      dataIndex: "Retenue IPM",
      key: "mont_retenue",
      align: "right",
      width: 140,
      render: (text) => (
        <div style={{ paddingRight: 5 }}>{formatNumber(parseFloat(text))}</div>
      ),
    },
    {
      title: "Retenue Paie",
      dataIndex: "Retenue Paie",
      key: "mont_retenue_soc",
      align: "right",
      width: 140,
      render: (text) => (
        <div style={{ paddingRight: 5 }}>{formatNumber(parseFloat(text))}</div>
      ),
    },
  ];

  const totalMontantRet = importedData.reduce(
    (sum, record) => sum + parseFloat(record["Retenue Paie"] || 0),
    0
  );
  const totalSoldesImport = importedData.reduce(
    (sum, record) => sum + parseFloat(record["Solde"] || 0),
    0
  );
  const exportToExcel2 = (data, fileName) => {
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  const prepareDataForExport = (data) => {
    return data.map((row) => ({
      CodeJ: row.codej,
      DateCompta: row.datecompta,
      MoisTrait: row.datetrait,
      NumPiece: row.numpiece,
      NumCheque: row.numcheque,
      NumFIPM: row.numfactipm,
      CompteGen: row.comptegen,
      CompteTiers: row.comptetiers,
      Matricule: row.matri,
      Libelle: row.libelle,
      Debit: row.debit,
      Credit: row.credit,
    }));
  };

  const handleValidCompta = async () => {
    try {
      const selectedRows = [...tableData];
      const payload = {
        comptas: comptaPreviewData,
        retenues: selectedRows,
      };
      const data = await retenueService.addValidRetenueCompta(payload);
      fetchData();
      setIsModalOpen(false);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données comptables :",
        error
      );
    }
  };


  const columns2 = [
    {
      title: "C.JL",
      dataIndex: "codej",
      key: "codej",
      align: "center",
      sorter: (a, b) => (a.codej || "").localeCompare(b.codej || ""),
    },
    {
      title: "D. Compta",
      dataIndex: "datecompta",
      key: "datecompta",
      align: "center",
      sorter: (a, b) =>
        (a.datecompta ? moment(a.datecompta).unix() : 0) -
        (b.datecompta ? moment(b.datecompta).unix() : 0),
      render: (text) => (
        <div>{text ? moment(text).format("DD/MM/YYYY") : ""}</div>
      ),
    },
    {
      title: "Mois trait.",
      dataIndex: "datetrait",
      key: "datetrait",
      align: "center",
      sorter: (a, b) =>
        (a.datetrait ? moment(a.datetrait).unix() : 0) -
        (b.datetrait ? moment(b.datetrait).unix() : 0),
      render: (text) => (
        <div>{text ? moment(text).format("MMM.YYYY") : ""}</div>
      ),
    },
    {
      title: "N° pièce",
      dataIndex: "numpiece",
      key: "numpiece",
      align: "center",
      sorter: (a, b) => (a.numpiece || "").localeCompare(b.numpiece || ""),
    },
    {
      title: "N° Chèque",
      dataIndex: "numcheque",
      key: "numcheque",
      align: "center",
      sorter: (a, b) => (a.numcheque || "").localeCompare(b.numcheque || ""),
    },
    {
      title: "N° F. IPM",
      dataIndex: "numfactipm",
      key: "numfactipm",
      align: "center",
      sorter: (a, b) => (a.numfactipm || "").localeCompare(b.numfactipm || ""),
    },
    {
      title: "Cpte. Gen.",
      dataIndex: "comptegen",
      key: "comptegen",
      align: "center",
      sorter: (a, b) => (a.comptegen || "").localeCompare(b.comptegen || ""),
    },
    {
      title: "Cpte. Tiers",
      dataIndex: "comptetiers",
      key: "comptetiers",
      align: "center",
      sorter: (a, b) => (a.comptetiers || "").localeCompare(b.comptetiers || ""),
    },
    {
      title: "Matricule",
      dataIndex: "matri",
      key: "matri",
      align: "center",
      sorter: (a, b) => (a.matri || "").localeCompare(b.matri || ""),
    },
    {
      title: "Libellé",
      dataIndex: "libelle",
      key: "libelle",
      sorter: (a, b) => (a.libelle || "").localeCompare(b.libelle || ""),
    },
    {
      title: "Débit",
      dataIndex: "debit",
      key: "debit",
      align: "right",
      sorter: (a, b) => (a.debit || 0) - (b.debit || 0),
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
    {
      title: "Crédit",
      dataIndex: "credit",
      key: "credit",
      align: "right",
      sorter: (a, b) => (a.credit || 0) - (b.credit || 0),
      render: (text) => (
        <div style={{ paddingRight: 5 }}>
          {text && parseFloat(text) !== 0 ? formatNumber(parseFloat(text)) : ""}
        </div>
      ),
    },
  ];

  const totalDebit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.debit || 0),
    0
  );
  const totalCredit1 = comptaPreviewData.reduce(
    (sum, record) => sum + parseFloat(record.credit || 0),
    0
  );
  const solde1 = totalDebit1 - totalCredit1;

  const handleImport = async () => {
    if (isImporting) return; // Empêche le double-clic pendant l'importation
    setIsImporting(true);
    try {
      const payload = importedData.map((data) => ({
        code_retenue: data["Code Retenue"],
        codesoc: data["Code soc."],
        matricule: data["Matricule"],
        mont_retenue: data["Retenue IPM"],
        mont_retenue_soc: data["Retenue Paie"],
        part: data["Participant"],
        solde: data["Solde"],
      }));

      const response = await retenueService.importRetenue(payload);
      handleCloseImportModal();
      notification.success({
        message: "Importation réussie",
        description: "Les données ont été importées avec succès.",
      });
      fetchData();
    } catch (error) {
      notification.error({
        message: "Erreur lors de l'importation",
        description:
          "Une erreur est survenue lors de l'importation des données.",
      });
    } finally {
      setIsImporting(false);
    }
  };

  const handleCloseImportModal = () => {
    setIsImportModalVisible(false);
    setImportedData([]);
    setImportErrors([]);
    setIsImporting(false);
  };


  const hasComptaOui = tableData.some((row) => row.compta === "Oui");
  // Le bouton "Comptabiliser" doit se désactiver si la sélection courante contient
  // au moins une ligne déjà comptabilisée (et non plus si c'est le cas ailleurs dans la table).
  const isComptaDisabled = selectedRows.some((row) => row.compta === "Oui");

  const isAppelRetenuDisabled = tableData.length > 0;

  return (
    <div>
      <Row gutter={16} style={{ padding: 12 }}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "10px 20px",
              background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
              borderRadius: 10,
              boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
            }}
          >
            <MinusCircleOutlined style={{ fontSize: 22, color: "#fff" }} />
            <span
              style={{
                fontSize: 18,
                fontWeight: 600,
                color: "#fff",
                letterSpacing: 0.5,
                margin: 0,
              }}
            >
              Retenues Frais Médicaux
            </span>
          </div>
          <p>
            <strong>
              {" "}
              {monthOptions.find((m) => m.value === selectedMonth)?.label ||
                "Mois non sélectionné"}{" "}
              {selectedYear} {/* {` ${getJournalLabel(selectJournal)}`} */} (
              {displayedTableData.length} Participant)
            </strong>
            <br />
            <Space>
              <span>
                <strong> Total Solde : {formatNumber(solde)}</strong>
              </span>
              <span>
                <strong>Total Retenue : {formatNumber(totalRetenue)}</strong>
              </span>
            </Space>
          </p>
        </Col>

        <Col xs={24} sm={24} md={16} lg={16} xl={16}>
          <Row gutter={16}>
            <Col xs={24} sm={24} md={8} lg={8} xl={11}>
              <Space style={{ width: "100%" }}>
                <Button
                  icon={<LeftOutlined />}
                  onClick={handlePreviousJournal}
                  disabled={currentJournalIndex <= 0}
                  style={{
                    backgroundColor: currentJournalIndex <= 0 ? undefined : "#000",
                    color: currentJournalIndex <= 0 ? undefined : "#fff",
                    borderColor: currentJournalIndex <= 0 ? undefined : "#000",
                  }}
                />
                <Select
                  bordered={false}
                  style={{
                    borderBottom: "2px solid #030303",
                    width: journalSelectWidth,
                    minWidth: journalSelectWidth,
                    maxWidth: journalSelectWidth,
                  }}
                  value={selectJournal}
                  onChange={handleSelectJournalChange}
                  showSearch
                  filterOption={(input, option) => {
                    const searchable = String(
                      option?.title ?? option?.value ?? ""
                    ).toLowerCase();
                    return searchable.includes(input.toLowerCase());
                  }}
                >
                  <Option
                    value="AA"
                    title="Toutes les sociétés"
                  >
                    <span
                      style={{
                        display: "inline-block",
                        width: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Toutes les sociétés
                    </span>
                  </Option>
                  {journalData.map((journal) => (
                    <Option
                      key={journal.codeadht}
                      value={journal.codeadht}
                      title={`${journal.codeadht} - ${journal.intitule}`}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {`${journal.codeadht} - ${journal.intitule}`}
                      </span>
                    </Option>
                  ))}
                </Select>
                <Button
                  icon={<RightOutlined />}
                  onClick={handleNextJournal}
                  disabled={currentJournalIndex === -1 || currentJournalIndex >= journalOptions.length - 1}
                  style={{
                    backgroundColor:
                      currentJournalIndex === -1 || currentJournalIndex >= journalOptions.length - 1
                        ? undefined
                        : "#000",
                    color:
                      currentJournalIndex === -1 || currentJournalIndex >= journalOptions.length - 1
                        ? undefined
                        : "#fff",
                    borderColor:
                      currentJournalIndex === -1 || currentJournalIndex >= journalOptions.length - 1
                        ? undefined
                        : "#000",
                  }}
                />
              </Space>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={4} style={{ marginLeft: "auto" }}>
              <Select
                className="select-colored-accent"
                style={{
                  width: "100%",
                  "--select-accent": "#1890ff",
                  "--select-accent-bg": "#e6f4ff",
                  "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                }}
                onChange={handleYearChange}
                value={selectedYear}
              >
                {lastFiveYears.map(year => (
                  <Select.Option key={year} value={String(year)}>
                    {year}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={4}>
              <Select
                className="select-colored-accent"
                style={{
                  width: "100%",
                  "--select-accent": "#722ed1",
                  "--select-accent-bg": "#f9f0ff",
                  "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                }}
                onChange={setSelectedMonth}
                value={selectedMonth}
              >
                {monthOptions.map((month) => (
                  <Option key={month.value} value={month.value}>
                    {month.label}
                  </Option>
                ))}
              </Select>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={4}
          style={{ display: "flex", justifyContent: "flex-start", marginBottom: 16 }}
        >
          <Input
            className="search-input-highlight"
            placeholder="Rechercher..."
            allowClear
            prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
            style={{ width: "100%" }}
            onChange={(e) => handleSearch(e.target.value)}
            onPressEnter={(e) => handleSearch(e.target.value)}
          />
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={12}
          xl={20}
          style={{ display: "flex", justifyContent: "end", marginBottom: 16 }}
        >
          <Flex wrap="wrap" gap="small">
            {/* <Dropdown overlay={selectionMenu} trigger={["click"]}>
              <Button
                style={{
                  backgroundColor: "#a8b156ff",
                  ":hover": { color: "white" },
                }}
              >
                Sélection <DownOutlined />
              </Button>
            </Dropdown> */}
            <Button
              style={{ background: "#024012", color: "white" }}
              onClick={handleClick}
              disabled={isAppelRetenuDisabled}
            >
              Appel Retenue
              <CloudUploadOutlined />
            </Button>
            <Button
              icon={<CalculatorOutlined />}
              className="buttonCompta"
              disabled={isTableEmpty || isComptaDisabled || selectedRows.length === 0 || totalRetenue === 0}
              onClick={handleComptabiliser}
            >
              Comptabiliser
            </Button>

            <Button
              className="buttonExport"
              onClick={() =>
                exportToExcel(
                  filteredTableData,
                  selectedMonth,
                  selectedYear,
                  selectJournal,
                  tableData,
                  monthOptions
                )
              }
              icon={<CloudDownloadOutlined />}
              disabled={isTableEmpty}
            >
              Export Excel
            </Button>

            <Button
              className="buttonImport"
              disabled={isTableEmpty || hasComptaOui}
              icon={<ImportOutlined />}
              onClick={() => {
                setImportedData([]);
                setImportErrors([]);
                setIsImportModalVisible(true);
              }}
            >
              Import Excel
            </Button>
            <style>{`
              .retenue-filter-select .ant-select-selector {
                border-radius: 20px !important;
                border: 1px solid #91caff !important;
                box-shadow: 0 2px 8px rgba(24, 144, 255, 0.15) !important;
                padding-left: 14px !important;
                transition: all 0.3s ease !important;
              }
              .retenue-filter-select:hover .ant-select-selector {
                border-color: #1890ff !important;
                box-shadow: 0 3px 10px rgba(24, 144, 255, 0.3) !important;
              }
              .retenue-filter-select.ant-select-focused .ant-select-selector {
                border-color: #1890ff !important;
                box-shadow: 0 0 0 3px rgba(24, 144, 255, 0.15) !important;
              }
            `}</style>
            <Select
              value={filterMode}
              onChange={(value) => handleFilterChange({ target: { value } })}
              className="retenue-filter-select"
              style={{ marginLeft: 16, minWidth: 190 }}
              suffixIcon={<DownOutlined style={{ color: "#1890ff" }} />}
              options={[
                {
                  value: "tout",
                  label: (
                    <span>
                      <FilterOutlined style={{ marginRight: 8, color: "#1890ff" }} />
                      Voir tout
                    </span>
                  ),
                },
                {
                  value: "anomalies",
                  label: (
                    <span>
                      <WarningOutlined style={{ marginRight: 8, color: "#faad14" }} />
                      Anomalies
                    </span>
                  ),
                },
                {
                  value: "normales",
                  label: (
                    <span>
                      <CheckCircleOutlined style={{ marginRight: 8, color: "#52c41a" }} />
                      Normales
                    </span>
                  ),
                },
              ]}
            />

            <Dropdown overlay={actionMenu} trigger={["click"]}>
              <Button icon={<MoreOutlined />} />
            </Dropdown>
          </Flex>
        </Col>
      </Row>

      <Table
        id="retenues-table"
        row
        loading={isLoading}
        scroll={{ x: true }}
        className="custom-header1-table"
        style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
        bordered
        pagination={{
          pageSizeOptions: ["5", "10", "20", "50", "100"], // Options disponibles pour la pagination
          showSizeChanger: true, // Permet à l'utilisateur de changer le nombre de lignes par page
          pageSize: pageSize, // Valeur actuelle du nombre de lignes par page
          onShowSizeChange: (current, size) => setPageSize(size), // Mise à jour de pageSize lors du changement
        }}
        showSorterTooltip={false}
        dataSource={filteredTableData}
        rowSelection={rowSelection}
        columns={columns}
        rowKey={getRetenueRowKey}
        onChange={handleRetenueTableChange}
      />

      <DraggableModal
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                color: "#fff",
                fontSize: 16,
              }}
            >
              <CloudUploadOutlined />
            </div>
            <span style={{ fontSize: 16, fontWeight: 600 }}>Appel Retenue Frais Médicaux</span>
          </div>
        }
        open={isModalVisible}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        width={640}
        style={{ top: 20 }}
        maskClosable={false}
        footer={[
          <Button key="back" icon={<CloseOutlined />} onClick={handleModalCancel}>
            Annuler
          </Button>,
          <Button
            key="submit"
            className="Buttonvalid"
            type="primary"
            icon={<CheckCircleOutlined />}
            style={{ backgroundColor: "#010f1c" }}
            onClick={handleModalOk}
            loading={isLoading} // Ajoute le spinner de chargement
          >
            {isLoading ? 'Chargement...' : 'Valider'}
          </Button>,
        ]}
      >
        <Form form={form} layout="vertical" style={{ marginTop: 8 }}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={
                  <span style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: 500 }}>
                    <CalendarOutlined style={{ color: "#1890ff" }} />
                    Année
                  </span>
                }
              >
                <Select
                  className="select-colored-accent"
                  style={{
                    width: "100%",
                    "--select-accent": "#1890ff",
                    "--select-accent-bg": "#e6f4ff",
                    "--select-accent-shadow": "rgba(24, 144, 255, 0.25)",
                  }}
                  onChange={handleYearChange}
                  value={selectedYear}
                >
                  {lastFiveYears.map((year) => (
                    <Select.Option key={year} value={String(year)}>
                      {year}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <span style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: 500 }}>
                    <CalendarOutlined style={{ color: "#722ed1" }} />
                    Mois
                  </span>
                }
              >
                <Select
                  className="select-colored-accent"
                  style={{
                    width: "100%",
                    "--select-accent": "#722ed1",
                    "--select-accent-bg": "#f9f0ff",
                    "--select-accent-shadow": "rgba(114, 46, 209, 0.25)",
                  }}
                  onChange={setSelectedMonth}
                  value={selectedMonth}
                >
                  {monthOptions.map((month) => (
                    <Option key={month.value} value={month.value}>
                      {month.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Form.Item
            label={
              <span style={{ display: "flex", alignItems: "center", gap: 6, fontWeight: 500 }}>
                <BankOutlined style={{ color: "#52c41a" }} />
                Société
              </span>
            }
          >
            <Select
              className="select-colored-accent"
              showSearch
              style={{
                width: "100%",
                "--select-accent": "#52c41a",
                "--select-accent-bg": "#f6ffed",
                "--select-accent-shadow": "rgba(82, 196, 26, 0.25)",
              }}
              value={selectJournal}
              onChange={handleSelectJournalChange}
            >
              <Option value="AA">Toutes les sociétés</Option>
              {journalData.map((journal) => (
                <Option key={journal.codeadht} value={journal.codeadht}>
                  {journal.codeadht} - {journal.intitule}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </DraggableModal>
      <DraggableModal
        title="Importer des retenues depuis un fichier Excel"
        open={isImportModalVisible}
        onCancel={isImporting ? undefined : handleCloseImportModal}
        maskClosable={!isImporting}
        closable={!isImporting}
        width="90%"
        style={{ maxWidth: 1050 }}
        footer={[
          <Button key="cancel" onClick={handleCloseImportModal} disabled={isImporting}>
            Annuler
          </Button>,
          <Button
            key="import"
            type="primary"
            onClick={handleImport}
            disabled={importedData.length === 0 || importErrors.length > 0 || isImporting}
            loading={isImporting}
          >
            {`Importer${importedData.length > 0 ? ` (${importedData.length})` : ""}`}
          </Button>,
        ]}
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message="Format du fichier attendu"
          description={
            <div>
              <p style={{ marginBottom: 4 }}>
                Fichier Excel (.xlsx) dont la première ligne contient exactement les
                colonnes suivantes, dans cet ordre :
              </p>
              <div style={{ overflowX: "auto" }}>
                <table style={{ borderCollapse: "collapse", marginTop: 4 }}>
                  <tbody>
                    <tr>
                      {IMPORT_RETENUE_COLUMNS.map((col) => (
                        <td
                          key={col}
                          style={{
                            border: "1px solid #91caff",
                            padding: "4px 10px",
                            background: "#fff",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <code>{col}</code>
                        </td>
                      ))}
                    </tr>
                  </tbody>
                </table>
              </div>
              <p style={{ marginTop: 8, marginBottom: 0 }}>
                Toutes les cellules doivent être renseignées. Les colonnes{" "}
                <code>Solde</code>, <code>Retenue IPM</code> et{" "}
                <code>Retenue Paie</code> doivent contenir des valeurs numériques.
              </p>
            </div>
          }
        />

        <Upload
          beforeUpload={handleExcelImport}
          accept=".xlsx, .xls"
          disabled={loading}
          showUploadList={false}
        >
          <Button icon={<CloudUploadOutlined />}>Sélectionner un fichier</Button>
        </Upload>

        {importErrors.length > 0 && (
          <>
            <Alert
              type="error"
              showIcon
              style={{ marginTop: 16 }}
              message={`${importErrors.length} anomalie(s) détectée(s) — corrigez le fichier puis réimportez-le`}
              action={
                <Button
                  size="small"
                  icon={<CloudDownloadOutlined />}
                  onClick={handleExportImportErrors}
                >
                  Exporter les anomalies
                </Button>
              }
            />
            <Table
              style={{ marginTop: 12 }}
              size="small"
              scroll={{ x: "max-content" }}
              pagination={{ pageSize: 10 }}
              dataSource={importErrors.map((err, idx) => ({ ...err, key: idx }))}
              columns={[
                { title: "Ligne Excel", dataIndex: "rowNum", width: 100 },
                { title: "Colonne", dataIndex: "field", width: 160 },
                { title: "Anomalie", dataIndex: "message" },
              ]}
            />
          </>
        )}

        {importedData.length > 0 && importErrors.length === 0 && (
          <>
            <Alert
              type="success"
              showIcon
              style={{ marginTop: 16, marginBottom: 12 }}
              message={`${importedData.length} ligne(s) valide(s), prêtes à être importées.`}
            />
            <Table
              loading={loading}
              scroll={{ x: 970, y: 400 }}
              tableLayout="fixed"
              className="custom-header1-table"
              style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
              showSorterTooltip={false}
              dataSource={importedData}
              columns={columns1}
              pagination={false}
              rowKey={(record, index) => `${record["Code Retenue"]}-${record["Matricule"]}-${index}`}
              bordered
            />
            <div style={{ marginTop: 16, textAlign: "right" }}>
              <Space>
                <strong>
                  Total Participants : {importedData.length} - Total Soldes :{" "}
                  {formatNumber(totalSoldesImport)} - Total Retenues :{" "}
                  {formatNumber(totalMontantRet)}
                </strong>
              </Space>
            </div>
          </>
        )}
      </DraggableModal>
      <DraggableModal
        title="Aperçu écritures au journal"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        maskClosable={false}
        footer={[
          <Button
            className="buttonExport"
            onClick={() =>
              exportToExcel2(
                prepareDataForExport(comptaPreviewData),
                "AperçuEcritureJournalExport.xlsx"
              )
            }
          >
            Export
          </Button>,
          <Button
            key="back"
            className="buttonClose"
            onClick={() => setIsModalOpen(false)}
          >
            Fermer
          </Button>,
          <Button
            className="Buttonvalid"
            // disabled={solde1 !== 0}
            onClick={handleValidCompta}
          >
            Valider
          </Button>,
        ]}
        width={1200}
        style={{ top: 20 }}
      >
        <Input
          placeholder="Recherche..."
          bordered={false}
          style={{
            borderBottom: "2px solid #030303",
            width: "20%",
            marginBottom: 30,
          }}
        />
        <Table
          scroll={{
            x: true,
          }}
          className="custom-header1-table"
          style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
          bordered
          showSorterTooltip={false}
          dataSource={comptaPreviewData}
          columns={columns2}
          footer={() => (
            <div style={{ textAlign: "right" }}>
              <Space>
                <strong>Total Débit : {formatNumber(totalDebit1)}</strong>
                <strong>Total Crédit : {formatNumber(totalCredit1)}</strong>
                <strong> Solde : {formatNumber(solde1)}</strong>
              </Space>
            </div>
          )}
        />
      </DraggableModal>
    </div>
  );
};

export default Retenue;
